export const ADMIN_ROUTES = {
  pay      : 'cartola/pagos',
  capsules : 'capsulas',
  reminders: 'recordatorios'
};
